<template>
  <div class="navs">
    <div class="topTabs">
       <div class="left">
          <div class="list"
            :class="item.name == $route.meta.title ? 'active' : ''"
            v-for="(item,index) in list" :key="index"
            @click="toPush(item,index)">
              {{item.name}}
          </div>
       </div>
    </div>
    <div class="fenge"></div>
  </div>
</template>

<script>
export default {
  name: 'topTabs',
  components: {},
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {},
  methods: {
    toPush (item, index) {
      console.log(item)
      if (item.windows) {
        window.open(item.url)
      } else {
        this.$router.push(item.url)
      }
    }
  }
}
</script>

<style scoped>
  .topTabs{
    position: relative;
    padding-left: 4.2667vw;
    height: 14.4667vw;
    display: flex;
    overflow: hidden;
    font-size: 4.8vw;

  }
  .left{
    line-height: 14.4667vw;
    display: flex;
    overflow-x: auto;
  }
  .left::-webkit-scrollbar {
    display: none;
  }
  .list{
    margin-right: 5.3333vw;
    white-space: nowrap;
  }
  .active{
    color: #4E55AF;
    border-bottom: 1px solid #4E55AF;
  }
  .fenge {
    width: 100vw;
    height: 2.1333vw;
    background: #F6F8FB;
    margin-bottom: 2.1333vw;
  }
</style>
